import Filter from "../Filter/Filter";
import Input from "../Input-new/Input";
import React from "react";
import SelectMultiTenantFilter from "../SelectMultiTenantFilter";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import SelectAgent from "../SelectAgent/SelectAgent";
import SelectFirm from "../SelectFirm/SelectFirm";
import Checkbox from "../CheckboxNew";
import SearchPanel from "../SearchPanel";
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";
import TerritoryTeam from "../TerritoryTeam/TerritoryTeam";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from "../../utils";
import territory from "../../territory";
import territoryProductType from "../../territory-product-type";
import territoryMarket from "../../territory-market";
import SelectBuyer from "./../SelectBuyer/SelectBuyer";
import SelectInvestor from "../SelectInvestor/SelectInvestor";

/** Labels for filter stepper dots — order must match the `panes` array below */
const LISTING_FILTER_PANE_TITLES = [
	'Property Info',
	'Property Stats',
	'Buyer / Seller',
	'MISC',
	'Peak',
	'Territories',
	'Reports',
];

export default class ListingFilter extends Filter {
    constructor(props) {
        super(props);
    }
    
    render() {
        const {query, buyerStateBreakdownCheckbox, transactionBreakdownCheckbox, marketTransactionBreakdownCheckbox, marketShareCheckbox, team_members, productTypes, markets, territories} = this.state;
        const isTransactionBreakdown = transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox;
        const isFinancing = query && (query.SOURCE === 'HSC' || query.SOURCE === 'PEAK');

        const mainCategory = query.MAIN_CATEGORY
            || (query.SUMMIT_YTD ? 'SUMMIT_YTD' : null)
            || (query.SUMMIT_CLOSINGS ? 'SUMMIT_CLOSINGS' : null)
            || (query.SUMMIT_NEGUC ? 'SUMMIT_NEGUC' : null)
            || (query.SUMMIT_INVENTORY ? 'SUMMIT_INVENTORY' : null);

        const panes = [
            (
                <div className='Filter_wrapper' style={{width: '100%'}}>
                    <h3>Property Info</h3>
                    <Input theme='dark'
                           valueType='text'
                           name='NAME'
                           label='Property Name'
                           value={query.NAME}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='ADDRESS'
                           label='Address'
                           value={query.ADDRESS}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='CITY'
                           label='City'
                           value={query.CITY}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        optionsType='states'
                        optionKey='abbr'
                        optionLabelKey='name'
                        value={query.STATE}
                        valueKey='STATE'
                        label='State'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Input theme='dark'
                        valueType='text'
                        name='ZIP'
                        label='Zip'
                        value={query.ZIP}
                        disabled={isTransactionBreakdown}
                        handleParentChange={this.handleChange}
                    />
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        optionsType='market'
                        optionLabelKey='name'
                        optionKey='code'
                        value={query.MARKET}
                        valueKey='MARKET'
                        label='Market'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                        options={[
                            {value: 'SUMMIT_YTD', label: 'Closings - YTD'},
                            {value: 'SUMMIT_CLOSINGS', label: 'SUMMIT Closings'},
                            {value: 'SUMMIT_NEGUC', label: 'In Negotiation / Under Contract'},
                            {value: 'SUMMIT_INVENTORY', label: 'Current Inventory'},
                        ]}
                        value={mainCategory}
                        valueKey='MAIN_CATEGORY'
                        label='Summit Stats'
                        data={query}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    {
                        isFinancing ?
                            <Dropdown dropdownType='multiple'
                                theme='dark'
                                optionsType='status-financing'
                                value={query.HSC_STATUS}
                                valueKey='HSC_STATUS'
                                label='Status'
                                data={query}
                                disabled={isTransactionBreakdown}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                            />
                            :
                            <Dropdown dropdownType='multiple'
                                theme='dark'
                                optionsType='status'
                                optionKey='code'
                                value={query.STATUS}
                                valueKey='STATUS'
                                label='Status'
                                data={query}
                                disabled={isTransactionBreakdown}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                            />
                    }
                    <Dropdown theme='dark'
                        optionsType='filter-source'
                        value={query.SOURCE}
                        valueKey='SOURCE'
                        label='Source'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                        optionsType='transaction'
                        value={query.TRANSACTION_TYPE}
                        valueKey='TRANSACTION_TYPE'
                        label='transaction Type'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        optionsType='category'
                        optionKey='code'
                        optionLabelKey='name'
                        value={query.CATEGORY}
                        valueKey='CATEGORY'
                        label='Category'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                     {query.CATEGORY=='apartments' && <Dropdown
                            theme='dark'
                            optionKey="code"
                            optionLabelKey="name"
                            data={query}
                            isFromProperty
                            optionsType="subcategory"
                            value={query.SUB_CATEGORY}
                            valueKey="SUB_CATEGORY"
                            label="Sub Category"
                            disabled={isTransactionBreakdown}
                            handleParentChange={this.handleDropdownChange}                           
                        />}
                        
                    {query.CATEGORY!='apartments' && <Dropdown theme='dark'
                              dropdownType='multiple'
                              optionsType='type'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.TYPE}
                              valueKey='TYPE'
                              label='Type'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    /> }
                    {
                        query.TYPE=== "STNL" && 
                        <React.Fragment>
                        {
                            getTenantSubcategorySTNL({data : query, handleChangeDropdown : this.handleDropdownChange, theme : 'dark', disabled:isTransactionBreakdown, isFilter:true}) 
                        } 
                            <Dropdown 
                                theme='dark'
                                optionsType='lease'
                                value={query.LEASE_TYPE}
                                valueKey='LEASE_TYPE'
                                label='Lease Type'
                                data={query}
                                disabled={isTransactionBreakdown}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                            />
                        </React.Fragment>
                    }
                    {
                        query.TYPE=== "MT" && getTenantSubcategoryMT({data : query, handleChangeDropdown : this.handleDropdownChange, theme : 'dark',disabled:isTransactionBreakdown, isFilter:true})
                    }   
                    {
                        query.TYPE === 'MT' &&
                        <SelectMultiTenantFilter theme='dark'
                                                    optionsType='tenant'
                                                    value={query.TENANT_ID}
                                                    valueKey='TENANT_ID'
                                                    label='Tenant'
                                                    data={query}
                                                    disabled={isTransactionBreakdown}
                                                    isFilter
                                                    handleParentChange={this.handleDropdownChange}
                        />
                    }
                    {query.CATEGORY=='apartments' && <DualRange theme='dark'
                               minValue={query.UNITS_MIN}
                               maxValue={query.UNITS_MAX}
                               minName='UNITS_MIN'
                               maxName='UNITS_MAX'
                               valueType='integer'
                               label='# of Units'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />}
                    {query.CATEGORY!='apartments' && <DualRange theme='dark'
                               minValue={query.SQFT_MIN}
                               maxValue={query.SQFT_MAX}
                               minName='SQFT_MIN'
                               maxName='SQFT_MAX'
                               valueType='integer'
                               label='Square Feet'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    /> }

                    

                   
                    <DualRange theme='dark'
                               minValue={query.LOT_SIZE_MIN}
                               maxValue={query.LOT_SIZE_MAX}
                               minName='LOT_SIZE_MIN'
                               maxName='LOT_SIZE_MAX'
                               valueType='integer'
                               label='Lot Size'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.YEAR_BUILT_MIN}
                               maxValue={query.YEAR_BUILT_MAX}
                               minName='YEAR_BUILT_MIN'
                               maxName='YEAR_BUILT_MAX'
                               valueType='number'
                               label='Year Built'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='COUNTY'
                           label='County'
                           value={query.COUNTY}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='ACCOUNT_NUMBER'
                           label='Account #'
                           value={query.ACCOUNT_NUMBER}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.ASSESSED_VALUE_MIN}
                               maxValue={query.ASSESSED_VALUE_MAX}
                               minName='ASSESSED_VALUE_MIN'
                               maxName='ASSESSED_VALUE_MAX'
                               valueType='integer'
                               label='Assessed Value'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.ASSESSED_YEAR_MIN}
                               maxValue={query.ASSESSED_YEAR_MAX}
                               minName='ASSESSED_YEAR_MIN'
                               maxName='ASSESSED_YEAR_MAX'
                               valueType='number'
                               label='Assessed Year'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.TRANS_DATE_MIN}
                               maxValue={query.TRANS_DATE_MAX}
                               minName='TRANS_DATE_MIN'
                               maxName='TRANS_DATE_MAX'
                               valueType='date'
                               label='Trans Date'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.TRANS_PRICE_MIN}
                               maxValue={query.TRANS_PRICE_MAX}
                               minName='TRANS_PRICE_MIN'
                               maxName='TRANS_PRICE_MAX'
                               valueType='integer'
                               label='Trans Price'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='checkbox'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CORE_PROPERTY}
                              valueKey='CORE_PROPERTY'
                              label='Core Property'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='checkbox'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.NEED_INFO}
                              valueKey='NEED_INFO'
                              label='Need Info'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='LEGAL_DESC'
                           label='Legal Description'
                           value={query.LEGAL_DESC}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='NOTES'
                           label='Notes'
                           value={query.NOTES}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (
                <div>
                    <h3>Property Stats</h3>
                    <DualRange theme='dark'
                               minValue={query.LIST_PRICE_MIN}
                               maxValue={query.LIST_PRICE_MAX}
                               minName='LIST_PRICE_MIN'
                               maxName='LIST_PRICE_MAX'
                               valueType='integer'
                               label='List Price'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CAPITALIZATION_RATE_MIN}
                               maxValue={query.CAPITALIZATION_RATE_MAX}
                               minName='CAPITALIZATION_RATE_MIN'
                               maxName='CAPITALIZATION_RATE_MAX'
                               valueType='percent'
                               label='List Cap Rate'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.PRICE_PER_SQFT_MIN}
                               maxValue={query.PRICE_PER_SQFT_MAX}
                               minName='PRICE_PER_SQFT_MIN'
                               maxName='PRICE_PER_SQFT_MAX'
                               valueType='integer'
                               label='Price Per Square Foot'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.SOLD_PRICE_MIN}
                               maxValue={query.SOLD_PRICE_MAX}
                               minName='SOLD_PRICE_MIN'
                               maxName='SOLD_PRICE_MAX'
                               valueType='integer'
                               label='Price at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CLOSE_CAP_RATE_MIN}
                               maxValue={query.CLOSE_CAP_RATE_MAX}
                               minName='CLOSE_CAP_RATE_MIN'
                               maxName='CLOSE_CAP_RATE_MAX'
                               valueType='percent'
                               label='Cap Rate at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CLOSE_PRICE_PER_SQFT_MIN}
                               maxValue={query.CLOSE_PRICE_PER_SQFT_MAX}
                               minName='CLOSE_PRICE_PER_SQFT_MIN'
                               maxName='CLOSE_PRICE_PER_SQFT_MAX'
                               valueType='integer'
                               label='Price Per Square Foot at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.NET_OPERATING_INCOME_MIN}
                               maxValue={query.NET_OPERATING_INCOME_MAX}
                               minName='NET_OPERATING_INCOME_MIN'
                               maxName='NET_OPERATING_INCOME_MAX'
                               valueType='integer'
                               label='Net Operating Income'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.OCCUPANCY_MIN}
                               maxValue={query.OCCUPANCY_MAX}
                               minName='OCCUPANCY_MIN'
                               maxName='OCCUPANCY_MAX'
                               valueType='percent'
                               label='Occupancy'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.LEASE_EXPIRATION_DATE_MIN}
                               maxValue={query.LEASE_EXPIRATION_DATE_MAX}
                               minName='LEASE_EXPIRATION_DATE_MIN'
                               maxName='LEASE_EXPIRATION_DATE_MAX'
                               valueType='number'
                               label='Remaining Term (years)'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.CLOSE_OF_ESCROW_MIN}
                               maxValue={query.CLOSE_OF_ESCROW_MAX}
                               minName='CLOSE_OF_ESCROW_MIN'
                               maxName='CLOSE_OF_ESCROW_MAX'
                               valueType='date'
                               label='Close of Escrow'
                               disabled={buyerStateBreakdownCheckbox || isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.LISTED_DATE_MIN}
                               maxValue={query.LISTED_DATE_MAX}
                               minName='LISTED_DATE_MIN'
                               maxName='LISTED_DATE_MAX'
                               valueType='date'
                               label='Date Listed'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (
                <div className='Filter_wrapper'>
                    <h3>Buyer / Seller</h3>
                    <SelectInvestor
                        theme='dark'
                        value={query.CURRENT_OWNER_ID}
                        valueKey="CURRENT_OWNER_ID"
                        label="Current Owner"
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    {/* Seller Name & Seller State filters — temporarily hidden per client request; restore if needed
                    <SelectInvestor
                        theme='dark'
                        value={query.SELLER_ID}
                        valueKey="SELLER_ID"
                        label="Seller Name"
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={query.SELLER_COMPANY_STATE}
                              valueKey='SELLER_COMPANY_STATE'
                              label='Seller State'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    */}
                    <SelectTeam theme='dark'
                                value={query.LISTING_AGENT_TEAM}
                                valueKey='LISTING_AGENT_TEAM'
                                label='SUMMIT TEAM MEMBER'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                onlyActive={true}
                                handleParentChange={this.handleDropdownChange}
                    />
                    <SelectAgent theme='dark'
                                 value={query.LISTING_AGENT_4}
                                 valueKey='LISTING_AGENT_4'
                                 label='LISTING AGENT'
                                 disabled={isTransactionBreakdown}
                                 data={query}
                                 isFilter
                                 handleParentChange={this.handleDropdownChange}
                    />
                    <SelectFirm theme='dark'
                                value={query.LISTING_AGENT_4_FIRM}
                                valueKey='LISTING_AGENT_4_FIRM'
                                label='LISTING AGENT FIRM'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                   
                    <SelectInvestor
                        theme='dark'
                        value={query.BUYER_ID}
                        valueKey="BUYER_ID"
                        label="Buyer Name"
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={query.BUYER_COMPANY_STATE}
                              valueKey='BUYER_COMPANY_STATE'
                              label='Buyer State'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <SelectAgent theme='dark'
                                 value={query.BUYER_AGENT_4}
                                 valueKey='BUYER_AGENT_4'
                                 label='BUYING AGENT'
                                 disabled={isTransactionBreakdown}
                                 data={query}
                                 isFilter
                                 handleParentChange={this.handleDropdownChange}
                    />
                    <SelectFirm theme='dark'
                                value={query.BUYER_AGENT_4_FIRM}
                                valueKey='BUYER_AGENT_4_FIRM'
                                label='BUYING AGENT FIRM'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='checkbox'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.NEED_OWNER}
                              valueKey='NEED_OWNER'
                              label='Need Owner'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='checkbox'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.RESEARCHED}
                              valueKey='RESEARCHED'
                              label='Researched'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                </div>
            ),
            (
                <div>
                    <h3>MISC</h3>
                    <DualRange theme='dark'
                               minValue={query.DATE_CREATED_MIN}
                               maxValue={query.DATE_CREATED_MAX}
                               minName='DATE_CREATED_MIN'
                               maxName='DATE_CREATED_MAX'
                               valueType='date'
                               label='Date Created'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='superUsers'
                              value={query.CREATED_BY}
                              valueKey='CREATED_BY'
                              label='Created By'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.LAST_MODIFIED_MIN}
                               maxValue={query.LAST_MODIFIED_MAX}
                               minName='LAST_MODIFIED_MIN'
                               maxName='LAST_MODIFIED_MAX'
                               valueType='date'
                               label='Last Modified'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='superUsers'
                              value={query.MODIFIED_BY}
                              valueKey='MODIFIED_BY'
                              label='Modified By'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='filters'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.EMPTY}
                              valueKey='EMPTY'
                              label='Empty'
                              data={query}
                              disabled={isTransactionBreakdown || buyerStateBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <div className='Filter_checkboxes'>
                        <div className='Filter_checkboxes_featured'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.FEATURED}
                                      valueKey='FEATURED'
                                      label='Featured'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='Filter_checkboxes_visible'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.VISIBLE}
                                      valueKey='VISIBLE'
                                      label='Visible'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                    </div>
                </div>
            ),(
                <div className='Filter_wrapper'>
                    <h3>Peak</h3>
                    <DualRange theme='dark'
                        minValue={query.LOAN_CLOSING_DATE_MIN}
                        maxValue={query.LOAN_CLOSING_DATE_MAX}
                        minName='LOAN_CLOSING_DATE_MIN'
                        maxName='LOAN_CLOSING_DATE_MAX'
                        valueType='date'
                        label='Loan Closing Date'
                        disabled={isTransactionBreakdown}
                        handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                        minValue={query.MATURITY_DATE_MIN}
                        maxValue={query.MATURITY_DATE_MAX}
                        minName='MATURITY_DATE_MIN'
                        maxName='MATURITY_DATE_MAX'
                        valueType='date'
                        label='Maturity Date'
                        disabled={isTransactionBreakdown}
                        handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (                
                <div className='Filter_wrapper'>
                    <h3>Territories</h3>
                    {/* <TerritoryTeam theme='dark'
                        value={query.TERRITORY_LISTING_AGENT_TEAM} 
                        valueKey='TERRITORY_LISTING_AGENT_TEAM'
                        label='SUMMIT Agent'
                        disabled={isTransactionBreakdown}
                        data={query}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                        items={this.state.items}
                    /> */}
                    <Dropdown theme='dark'
                        optionsType='team'
                        options={team_members ? team_members : []}
                        optionKey='ARCIMEDES_ROW_ID'
                        optionLabelKey='Team Member'
                        value={query.TERRITORY_LISTING_AGENT_TEAM}
                        valueKey='TERRITORY_LISTING_AGENT_TEAM'
                        label='SUMMIT Agent'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        optionKey='ARCIMEDES_ROW_ID'
                        optionLabelKey='NAME'
                        data={query}
                        options={productTypes}
                        value={query.PRODUCT_TYPE}
                        valueKey="PRODUCT_TYPE"
                        label="Product Type"
                        handleParentChange={this.handleDropdownChange}
                        isFilter
                        optionsType="productType"
                        // disabled={query.hasOwnProperty('TERRITORY_LISTING_AGENT_TEAM')}
                    />
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        data={query}
                        optionLabelKey='NAME'
                        optionKey='ARCIMEDES_ROW_ID'
                        options={markets}
                        value={query.TERRITORY_MARKET}
                        valueKey="TERRITORY_MARKET"
                        label="Market"
                        handleParentChange={this.handleDropdownChange}
                        isFilter
                        optionsType="territoryMarket"
                        // disabled={query.hasOwnProperty('TERRITORY_LISTING_AGENT_TEAM')}
                    />
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        data={query}
                        optionLabelKey='NAME'
                        optionKey='ARCIMEDES_ROW_ID'
                        options={territories}
                        value={query.TERRITORY}
                        valueKey="TERRITORY"
                        label="TERRITORIES"
                        handleParentChange={this.handleDropdownChange}
                        isFilter
                        optionsType="territory"
                        // disabled={query.hasOwnProperty('TERRITORY_LISTING_AGENT_TEAM')}
                    />
                    {/* <Dropdown
                        theme='dark'
                        data={query}
                        optionKey='code'
                        optionLabelKey='name'
                        options={territory}
                        value={query.TERRITORY}
                        valueKey="TERRITORY"
                        label="Territory"
                        handleParentChange={this.handleDropdownChange}
                        isFilter
                        optionsType="territory"
                        disabled={query.hasOwnProperty('TERRITORY_LISTING_AGENT_TEAM')}
                        dropdownType='multiple'
                    /> */}
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        optionsType='status'
                        optionKey='code'
                        value={query.STATUS}
                        valueKey='STATUS'
                        label='Status'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                        optionsType='transaction'
                        value={query.TRANSACTION_TYPE}
                        valueKey='TRANSACTION_TYPE'
                        label='transaction Type'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    {(query.STATUS && query.STATUS.includes('Closed')) &&
                        <DualRange theme='dark'
                                minValue={query.CLOSE_OF_ESCROW_MIN}
                                maxValue={query.CLOSE_OF_ESCROW_MAX}
                                minName='CLOSE_OF_ESCROW_MIN'
                                maxName='CLOSE_OF_ESCROW_MAX'
                                valueType='date'
                                label='Close of Escrow'
                                disabled={buyerStateBreakdownCheckbox || isTransactionBreakdown}
                                handleParentChange={this.handleChange}
                        />
                    }
                    {(query.STATUS && query.STATUS.includes('Active')) &&
                        <DualRange theme='dark'
                                minValue={query.LISTED_DATE_MIN}
                                maxValue={query.LISTED_DATE_MAX}
                                minName='LISTED_DATE_MIN'
                                maxName='LISTED_DATE_MAX'
                                valueType='date'
                                label='Date Listed'
                                disabled={isTransactionBreakdown}
                                handleParentChange={this.handleChange}
                        />
                    }
                </div>
            ),
            (
                <div>
                    <h3>Reports</h3>
                    <Checkbox darkMode
                              text='Buyer State Breakdown'
                              type={isTransactionBreakdown ? 'uncheckable' : 'checkable'}
                              name='buyerStateBreakdownCheckbox'
                              isSelected={buyerStateBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <DualRange theme='dark'
                               minValue={buyerStateBreakdownCheckbox ? query.BASE_MIN : ''}
                               maxValue={buyerStateBreakdownCheckbox ? query.BASE_MAX : ''}
                               minName='BASE_MIN'
                               maxName='BASE_MAX'
                               valueType='date'
                               label='Base'
                               disabled={!buyerStateBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={buyerStateBreakdownCheckbox ? query.COMPARISON_MIN : ''}
                               maxValue={buyerStateBreakdownCheckbox ? query.COMPARISON_MAX : ''}
                               minName='COMPARISON_MIN'
                               maxName='COMPARISON_MAX'
                               valueType='date'
                               label='Comparison'
                               disabled={!buyerStateBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />

                    <Checkbox darkMode
                              text='Transaction Breakdown'
                              type={buyerStateBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox ? 'uncheckable' : 'checkable'}
                              name='transactionBreakdownCheckbox'
                              isSelected={transactionBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <Input theme='dark'
                           valueType='number'
                           name='TRANSACTION_YEAR'
                           label='Transaction Year'
                           value={query.TRANSACTION_YEAR}
                           disabled={!transactionBreakdownCheckbox}
                           placeholder='YYYY'
                           handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='type'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.TYPE}
                              valueKey='TYPE'
                              label='Type'
                              data={query}
                              disabled={!transactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    {
                        query.TYPE === 'MT' && transactionBreakdownCheckbox &&
                        <React.Fragment>
                            <DualRange theme='dark'
                                       minValue={query.SOLD_PRICE_MIN}
                                       maxValue={query.SOLD_PRICE_MAX}
                                       minName='SOLD_PRICE_MIN'
                                       maxName='SOLD_PRICE_MAX'
                                       valueType='integer'
                                       label='Sale Price'
                                       handleParentChange={this.handleChange}
                            />
                            <DualRange theme='dark'
                                       minValue={query.SQFT_MIN}
                                       maxValue={query.SQFT_MAX}
                                       minName='SQFT_MIN'
                                       maxName='SQFT_MAX'
                                       valueType='integer'
                                       label='Size'
                                       handleParentChange={this.handleChange}
                            />
                        </React.Fragment>
                    }
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CATEGORY}
                              valueKey='CATEGORY'
                              label='Category'
                              data={query}
                              disabled={!transactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />

                    <Checkbox darkMode
                              text='Market Transaction Breakdown'
                              type={buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketShareCheckbox ? 'uncheckable' : 'checkable'}
                              name='marketTransactionBreakdownCheckbox'
                              isSelected={marketTransactionBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />

                    <DualRange theme='dark'
                               minValue={marketTransactionBreakdownCheckbox ? query.BASE_MIN : ''}
                               maxValue={marketTransactionBreakdownCheckbox ? query.BASE_MAX : ''}
                               minName='BASE_MIN'
                               maxName='BASE_MAX'
                               valueType='date'
                               label='Base'
                               disabled={!marketTransactionBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={marketTransactionBreakdownCheckbox ? query.COMPARISON_MIN : ''}
                               maxValue={marketTransactionBreakdownCheckbox ? query.COMPARISON_MAX : ''}
                               minName='COMPARISON_MIN'
                               maxName='COMPARISON_MAX'
                               valueType='date'
                               label='Comparison'
                               disabled={!marketTransactionBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CATEGORY}
                              valueKey='CATEGORY'
                              label='Category'
                              data={query}
                              disabled={!marketTransactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='market'
                              value={query.MARKET}
                              valueKey='MARKET'
                              label='Market'
                              optionLabelKey='name'
                              optionKey='code'
                              data={query}
                              disabled={!marketTransactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Checkbox darkMode
                              text='Market Share Report'
                              type={buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox ? 'uncheckable' : 'checkable'}
                              name='marketShareCheckbox'
                              isSelected={marketShareCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.CATEGORY}
                              valueKey='CATEGORY'
                              label='Category'
                              data={query}
                              disabled={!marketShareCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='market'
                              value={query.MARKET}
                              valueKey='MARKET'
                              label='Market'
                              optionLabelKey='name'
                              optionKey='code'
                              data={query}
                              disabled={!marketShareCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                </div>
            ),
        ];

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {React.cloneElement(this.props.children, {
                        userData: this.props.userData,
                        openFilter: () => this.openFilter()
                    })}
                </div>
                <SearchPanel ref='searchPanel' class="properties-top">
                    <form onSubmit={this.handleSubmit}>
                        <nav className='Filter_nav'>
                            <div className='Filter_button list' onClick={() => this.navigateTo('/list')}>List</div>
                            <div className='Filter_button' onClick={() => this.navigateTo('/map')}>Map</div>
                            <div className='Filter_button' onClick={this.close}>Close</div>
                        </nav>
                        <div className='Filter_slider'>
                            {panes.map((el, key) => {
                                const paneTitle = LISTING_FILTER_PANE_TITLES[key] || `Section ${key + 1}`;
                                return (
                                    <Control
                                        key={key}
                                        className='Filter_slider_control'
                                        onClick={() => this.handlePaneChange(key)}
                                        aria-label={paneTitle}
                                    >
                                        <div
                                            className={'Filter_slider_icon' + (key === this.state.paneIndex ? ' Filter_slider_icon--active' : '')}
                                        />
                                        <span className='Filter_slider_tooltip' aria-hidden="true">
                                            {paneTitle}
                                        </span>
                                    </Control>
                                );
                            })}
                        </div>
                        {panes[this.state.paneIndex]}
                        <div className='Filter_buttons'>
                            <button type='button' className='button-new negative dark' onClick={this.clear}>Clear</button>
                            <button className='button-new positive'>Apply</button>
                        </div>
                    </form>
                </SearchPanel>
            </div>
        );
    }
}
